// require('./util/ga-dev-fallback');

export default () => jQuery(($) => {
	require('./util/foreach-polyfill');

	// vanilla javascript for getting a parent that matches a selector
	// matches might not be supported by IE and older browser versions
	let getClosest = (elem, selector) => {
		for (; elem && elem !== document; elem = elem.parentNode) {
			if (elem.matches(selector)) return elem;
		}
		return null;
	};

	// track when a person expands an 'overlay' section
	let buttons = document.querySelectorAll('.overlay__disclose-button');
	let mobileButtons = document.querySelectorAll('.overlay__mobile-disclose-button');
	buttons.forEach(btn => {
		btn.addEventListener('click', () => {
			let eventTarget = getClosest(btn, '.overlay--with-image').id;
			ga('send', 'event', 'Homepage', 'Expand Message', eventTarget);
		}, {
			once: true,
		});
	});

	mobileButtons.forEach(btn => {
		btn.addEventListener('click', () => {
			let eventTarget = getClosest(btn, '.overlay--with-image').id;
			ga('send', 'event', 'Homepage', 'Expand Message (mobile)', eventTarget);
		}, {
			once: true,
		});
	});

	// track when a person searches for something, and what they search for
	let searchForms = document.querySelectorAll('.search-form__form');
	searchForms.forEach(form => {
		form.addEventListener('submit', (e) => {
			ga('send', 'event', 'Homepage', 'Search', form.elements["q"].value);
		});
	});

	// track when a person clicks play on a video
	let videos = document.querySelectorAll('.av-placeholder__activator')
	videos.forEach(video => {
		video.addEventListener('click', () => {
			for (let i=0; i<video.childNodes.length; i++) {
				if (video.childNodes[i].className='av-placeholder__label') {
					let val = video.childNodes[i].parentNode.textContent.replace(/\r?\n|\r/g, '').replace(/\s{2,}/g, ' ').trim();
					ga('send', 'event', 'Homepage', 'Play Video', val);
					break;
				}
			}
		});
	});

	// track when a person scrolls into a new section of the page
	if(!!window.IntersectionObserver) {
		let observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach(entry => {
					if (entry.intersectionRatio > 0 || entry.isIntersecting) {
						if (!entry.target.classList.contains('analytics--viewed')) {
							entry.target.classList.add('analytics--viewed');
							ga('send', 'event', 'Homepage', 'Scrolled To', entry.target.id, {'nonInteraction': 1});
						}
						observer.unobserve(entry.target);
					}
				});
			},
			{
				root: null,
                rootMargin: "0px 0px -20% 0px"
			}
		);
		document.querySelectorAll('#teaching, #community, #curiosity, #lifetime, #affordability').forEach(block => {
			observer.observe(block);
		});
	}
});
